import { render, staticRenderFns } from "./ScrollListFB.vue?vue&type=template&id=3a05cb40&scoped=true"
import script from "./ScrollListFB.vue?vue&type=script&lang=js"
export * from "./ScrollListFB.vue?vue&type=script&lang=js"
import style0 from "./ScrollListFB.vue?vue&type=style&index=0&id=3a05cb40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05cb40",
  null
  
)

export default component.exports